/**
 * Chặn thoát origin: absolute URL (`https://evil.com`), protocol-relative (`//evil.com`), và trick
 * backslash (`/\evil.com` — browser normalize `\` thành `/`). KHÔNG loại `/signin`, nên dùng cho
 * đích điều hướng thật (`location.href`) nơi signin là điểm đến hợp lệ.
 */
export function isSameOriginPath(value: unknown): value is string {
  if (typeof value !== 'string' || value.length === 0) {
    return false;
  }
  // Ký tự điều khiển đi TRƯỚC mọi phép soi vị trí: thuật toán URL của WHATWG XOÁ tab/LF/CR ở BẤT
  // KỲ đâu trong chuỗi rồi mới parse, nên `/<TAB>/evil.com` biến thành `//evil.com` SAU khi hàm này
  // đã gật đầu — đo được `new URL('/\t/evil.com', origin).href === 'https://evil.com/'`. Soi
  // `value[1]` không thấy gì vì ký tự thứ hai lúc đó là TAB, không phải `/`.
  for (let i = 0; i < value.length; i += 1) {
    const code = value.charCodeAt(i);
    if (code <= 0x1F || code === 0x7F) {
      return false;
    }
  }
  if (value[0] !== '/') {
    return false;
  }
  // Reject `//...` and `/\...` (second char opening an authority component).
  if (value[1] === '/' || value[1] === '\\') {
    return false;
  }
  return true;
}

/** Bản cho `?redirect=`: thêm điều kiện loại chính màn signin, nếu không sẽ loop về login. */
export function isSafeInternalPath(value: unknown): value is string {
  return isSameOriginPath(value) && !value.startsWith('/signin');
}

/**
 * Extracts a safe redirect path from a route-query `redirect` value, which may
 * be a string, a string array (repeated key), or absent. Returns the path when
 * it is a safe internal path, otherwise `null`.
 */
export function getSafeRedirectPath(raw: unknown): string | null {
  const target = Array.isArray(raw) ? raw[0] : raw;
  return isSafeInternalPath(target) ? target : null;
}
